import { render, staticRenderFns } from "./Backpack.vue?vue&type=template&id=39cf09c0&scoped=true&"
import script from "./Backpack.vue?vue&type=script&lang=js&"
export * from "./Backpack.vue?vue&type=script&lang=js&"
import style0 from "./Backpack.vue?vue&type=style&index=0&id=39cf09c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cf09c0",
  null
  
)

export default component.exports